// Copyright Epic Games, Inc. All Rights Reserved.

export const SET_MAIN_SERVICE_ACCESS_TOKEN = "SET_MAIN_SERVICE_ACCESS_TOKEN";

export interface ISetMainServiceAccessToken {
  type: typeof SET_MAIN_SERVICE_ACCESS_TOKEN;
  payload: {
    mainServiceAccessToken: string;
  };
}

export type SharedStateActionTypes = ISetMainServiceAccessToken;

export function setMainServiceAccessToken(
  mainServiceAccessToken: string
): ISetMainServiceAccessToken {
  return {
    type: SET_MAIN_SERVICE_ACCESS_TOKEN,
    payload: {
      mainServiceAccessToken,
    },
  };
}
